import React from 'react';

import './Projects.css';

const projectsData = [
    {
        title: 'E-Commerce Growth Strategy',
        description: 'Increased online revenue by 300% through integrated SEO, PPC, and conversion optimization strategies for a leading retail brand.',
        tags: ['SEO', 'Google Ads', 'CRO']
    },
    {
        title: 'B2B Lead Generation Campaign',
        description: 'Generated 500+ qualified leads per month through targeted LinkedIn ads and content marketing for a SaaS company.',
        tags: ['LinkedIn Ads', 'Content Marketing', 'Lead Gen']
    }
];

const Projects = () => {
    return (
        <section className="projects" id="projects">

            <div className="container-wide">
                {projectsData.map((project, index) => (
                    <div className="project-sticky" key={index}>
                        <div className="project-card">
                            {/* IMAGE PLACEHOLDER: Add project screenshot or dashboard here (recommended size: 800x600px) */}
                            <div className="project-image">
                                <div className="project-image-placeholder">
                                    <p>📊 Add Project Screenshot</p>
                                </div>
                            </div>
                            <div className="project-content">
                                <h2>{project.title}</h2>
                                <p>{project.description}</p>
                                <div className="project-tags">
                                    {project.tags.map((tag, tagIndex) => (
                                        <span className="project-tag" key={tagIndex}>{tag}</span>
                                    ))}
                                </div>
                                <a href="/case-studies" className="btn btn-primary">
                                    View Case Study
                                    <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Projects;
